import { render, staticRenderFns } from "./ModalMandateLanguage.vue?vue&type=template&id=35dcc4cc&scoped=true&"
import script from "./ModalMandateLanguage.vue?vue&type=script&lang=js&"
export * from "./ModalMandateLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dcc4cc",
  null
  
)

export default component.exports